import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var Timer = /*#__PURE__*/function () {
  function Timer(opts, ms) {
    _classCallCheck(this, Timer);

    if (!opts.onEnd) throw new Error('onEnd handler is required');
    if (!ms) throw new Error('ms duration is required');
    this.onEnd = opts.onEnd;
    this.initialMs = ms;
    this.startTimestamp = Date.now();
    this.timer = this.create(this.onEnd, ms);
  }

  _createClass(Timer, [{
    key: "create",
    value: function create(cb, ms) {
      var _this = this;

      if (this.timer) this.clear();
      return setTimeout(function () {
        return cb ? cb() : _this.onEnd();
      }, ms || this.initialMs);
    }
  }, {
    key: "clear",
    value: function clear() {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }, {
    key: "end",
    value: function end() {
      this.clear();
      this.onEnd();
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return this.initialMs - (Date.now() - this.startTimestamp) > 0;
    }
  }]);

  return Timer;
}();